import React, {
  Dispatch, SetStateAction, useContext, useEffect, useState,
} from 'react';
import { useIntercom } from 'react-use-intercom';
import { AuthContext, UserDataContext } from '../../App';
import { dbListenToTasksForUser } from '../../database/firebaseTasksAPI';
import { rejectedMeetingData } from '../../database/utils/templateMeetingData';
import { SidebarStateContext } from '../../ListenToSidebarMessageContainer';
import CreateNewTaskModal from '../../shared/components/task-modal/CreateNewTaskModal';
import Tasks from '../../shared/components/tasks';
import { TaskItems, TaskTab, Page } from '../../shared/types/types';
import { logPageEvent } from '../../utils/analytics/eventLogger';
import { shouldWeLog } from '../../utils/analytics/functions';
import { ALL_TASKS_PAGE, ALL_PAGES } from '../../utils/enums';
import { pendingTaskItems } from '../../utils/tasks/tasksUtils';
import WelcomeBanner from './welcomeBanner';

// const TaskTabMaxHeight = 'calc(100vh - 48px - 49px - 110px - 127px)';
// const TaskTabMaxHeight = 'calc(100vh - 48px - 110px - 110px)';

interface Props {
  page: Page,
  // eslint-disable-next-line no-unused-vars
  setPage: (page: Page) => void,
  taskTab: TaskTab,
  setTaskTab: Dispatch<SetStateAction<TaskTab>>,
}

const AllTasksOrganism = ({
  page, setPage, taskTab, setTaskTab,
}: Props) => {
  const authState = useContext(AuthContext);
  const userData = useContext(UserDataContext);
  const isSidebarOpen = useContext(SidebarStateContext);
  const { trackEvent } = useIntercom();
  const [taskItems, setTaskItems] = useState<TaskItems>(pendingTaskItems);
  const [isCreateTaskModalOpen, setCreateTaskModalOpen] = useState<boolean>(false);
  const [isWelcomeBannerOpened, setWelcomeBannerClosed] = useState<boolean>(true);

  useEffect(() => {
    if (authState.email.length === 0) return () => { };
    if (page !== ALL_PAGES.ALL_TASKS) return () => { };
    return dbListenToTasksForUser(authState.email, setTaskItems);
  }, [authState, page]);

  useEffect(() => {
    // Analytics event logging
    if (page !== ALL_PAGES.ALL_TASKS) return;
    if (shouldWeLog(userData, isSidebarOpen)) return;
    logPageEvent(authState.userId, trackEvent, ALL_TASKS_PAGE);
  }, [page, isSidebarOpen]);

  const handleWelcomeBannerClose = () => {
    setWelcomeBannerClosed(false);
  };

  const handleCloseCreateTaskModal = () => setCreateTaskModalOpen(false);

  if (page !== ALL_PAGES.ALL_TASKS) return null;
  /** Height of the task content when the welcome banner is opened and closed  */
  const TaskTabMaxHeight = isWelcomeBannerOpened ? 'calc(100vh - 110px - 110px - 17px)' : 'calc(100vh - 48px - 110px + 29px)';

  return (
    <>
      <WelcomeBanner
        handleWelcomeBannerClose={handleWelcomeBannerClose}
        page={page}
        isClosed={!isWelcomeBannerOpened}
      />
      <Tasks
        taskTab={taskTab}
        setTaskTab={setTaskTab}
        taskItems={taskItems}
        setPage={setPage}
        setCreateTaskModalOpen={setCreateTaskModalOpen}
        height={TaskTabMaxHeight}
        taskPage={ALL_TASKS_PAGE}
        disableAssigneeSelect
      />
      <CreateNewTaskModal
        meetingData={rejectedMeetingData}
        isModalOpen={isCreateTaskModalOpen}
        setModalClosed={handleCloseCreateTaskModal}
      />
    </>
  );
};

export default AllTasksOrganism;
